import React from 'react';
import { cn } from '../../lib/cn';

interface ChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  count?: number;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

export const Chip: React.FC<ChipProps> = ({
  active = false,
  count,
  icon,
  children,
  className,
  ...props
}) => {
  return (
    <button
      type="button"
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1 rounded-full',
        'text-xs font-medium whitespace-nowrap',
        'border transition-colors',
        active
          ? 'bg-indigo-600 text-white border-indigo-600 hover:bg-indigo-700 hover:border-indigo-700'
          : 'bg-white text-gray-700 border-gray-300 hover:border-gray-400 hover:bg-gray-50 dark:bg-zinc-900 dark:text-zinc-200 dark:border-zinc-700 dark:hover:border-zinc-600 dark:hover:bg-zinc-800/60',
        className
      )}
      {...props}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      {children}
      {count != null && (
        <span
          className={cn(
            'ml-0.5 rounded-full px-1.5 text-[10px] leading-tight',
            active ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-600 dark:bg-zinc-800 dark:text-zinc-300'
          )}
        >
          {count}
        </span>
      )}
    </button>
  );
};

export default Chip;
